import { render } from "./OverviewDemoChart.vue?vue&type=template&id=6786bf59"
import script from "./OverviewDemoChart.vue?vue&type=script&lang=js"
export * from "./OverviewDemoChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__